module.exports = __webpack_public_path__ + "img/logo-passbucket-320.7ca082b6.png";